import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { RecentSearch } from '../../model/recent-search.model';

declare let delta: any;

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'recent-searches',
  templateUrl: 'recent-searches.component.html'
})
export class RecentSearchesComponent {
  @Input() recentSearchResult: any[] = [];
  @Output() selectedResult: EventEmitter<RecentSearch> =
    new EventEmitter<RecentSearch>();

  constructor(public bsModalRef: BsModalRef) {}

  populateRecentSearch(recentList) {
    this.selectedResult.emit(recentList);
  }

  getFromAirportCode(recentSearch) {
    if (!recentSearch) {
      return '';
    }
    const airport = this.multicityAirportsExist(recentSearch)
      ? recentSearch.airports[0]
      : recentSearch.airports;
    if (!airport) {
      return '';
    }
    return airport.fromAirportcode;
  }

  getToAirportCode(recentSearch) {
    if (!recentSearch) {
      return '';
    }
    const airport = this.multicityAirportsExist(recentSearch)
      ? recentSearch.airports[0]
      : recentSearch.airports;
    if (!airport) {
      return '';
    }
    return airport.toAirportcode;
  }

  getDepartureDate(recentSearch) {
    if (!recentSearch) {
      return '';
    }
    const date = this.multicityDatesExist(recentSearch)
      ? recentSearch.dates[0]
      : recentSearch.dates;
    if (!date) {
      return '';
    }
    return date.departureDate;
  }

  private multicityAirportsExist(recentSearch): boolean {
    return (
      recentSearch.selectTripType === 'MULTICITY' &&
      recentSearch.airports &&
      recentSearch.airports.length
    );
  }

  private multicityDatesExist(recentSearch): boolean {
    return (
      recentSearch.selectTripType === 'MULTICITY' &&
      recentSearch.dates &&
      recentSearch.dates.length
    );
  }
}
